import { ChevronUp, ChevronDown, ChevronsUpDown } from "lucide-react";

/**
 * SortableTh — clickable <th> with a sort-direction indicator.
 * Drop-in replacement for a plain <th>; pairs with useSortableData().
 */
export function SortableTh({
    label, sortKey, currentKey, direction, onSort,
    align = "left", className = "", testId,
}) {
    const active = currentKey === sortKey;
    const Icon = active ? (direction === "asc" ? ChevronUp : ChevronDown) : ChevronsUpDown;
    return (
        <th className={`${align === "right" ? "text-right" : "text-left"} px-3 py-2 ${className}`}>
            <button
                type="button"
                onClick={() => onSort(sortKey)}
                data-testid={testId || `sort-th-${sortKey}`}
                className={
                    "inline-flex items-center gap-1 select-none transition-colors hover:text-foreground " +
                    (align === "right" ? "flex-row-reverse" : "") + " " +
                    (active ? "text-foreground font-semibold" : "text-muted-foreground")
                }
            >
                <span>{label}</span>
                <Icon className={`w-3 h-3 shrink-0 ${active ? "opacity-100" : "opacity-40"}`} />
            </button>
        </th>
    );
}
